(function() {
    window.c24OnRenderQtip = function() {};

    window.c24RepositionQTip = function(api, position, useWrapper) {
        let qtipWrapper = {};
        if (useWrapper === undefined || useWrapper === true) {
            qtipWrapper = api.target.closest('.qtipWrapper');
        }

        if (qtipWrapper.length > 0 &&
        api.position.my.y === 'center' &&
        (api.position.my.x === 'left' || api.position.my.x === 'right')) {
            const scrollTop = $(window).scrollTop();
            const qtipWrapperTop = qtipWrapper.offset().top;
            const qtipWrapperHeight = qtipWrapper.height();
            const tooltip = api.elements.tooltip;
            const tooltipHeight = tooltip.height();
            const tooltipTip = $('.qtip-tip', tooltip);
            let tooltipTipCenter = null;
            let newVerticalPos = null;

            switch (api.position.at.y) {
                case 'top':
                    tooltipTipCenter = Math.round(api.target.offset().top);
                    break;
                case 'bottom':
                    tooltipTipCenter = Math.round(api.target.offset().top + api.target.height());
                    break;
                case 'center':
                default:
                    tooltipTipCenter = Math.round(api.target.offset().top + (api.target.height() / 2));
                    break;
            }

            if (tooltipHeight > qtipWrapperHeight) {
            // Tooltip is too big to show within the wrapper
                newVerticalPos = Math.round(qtipWrapperTop + qtipWrapperHeight - tooltipHeight - 5);
                if (newVerticalPos < scrollTop) {
                    newVerticalPos = scrollTop;
                }

            } else {
            // Qtip fits in the wrapper
                if (tooltipTipCenter < qtipWrapperTop + (qtipWrapperHeight / 2)) {
                // Tipcenter is closer to the top
                    newVerticalPos = Math.round(qtipWrapperTop + 5);
                } else {
                // Tipcenter is closer to the bottom
                    newVerticalPos = Math.round(qtipWrapperTop + qtipWrapperHeight - tooltipHeight - 5);
                }

                if (newVerticalPos < scrollTop) {
                    newVerticalPos = scrollTop;
                }
            }

            if (newVerticalPos !== null) {
                if (newVerticalPos > tooltipTipCenter - tooltipTip.height()) {
                    newVerticalPos = tooltipTipCenter - tooltipTip.height();
                }

                let tooltipTipTop = tooltipTipCenter - newVerticalPos - (tooltipTip.height() / 2);
                if (tooltipTipTop > tooltipHeight) {
                    const verticalShift = tooltipTipTop - tooltipHeight + tooltipTip.height();
                    newVerticalPos += verticalShift;
                    tooltipTipTop -= verticalShift;
                }

                position.top = newVerticalPos;
                tooltipTip.css('margin-top', '0');
                tooltipTip.css('top', tooltipTipTop + 'px');
            }
        }
    };
})();
